export default __webpack_public_path__ + "static/bunker-web-3-99394d929a4484f9a2aac0f39f703498.jpg";